import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { GuardarNuevoTipoServicio } from '../../helpers/ServiciosHelper';
import { TiposServicioContext } from '../../pages/catalogos/ServiciosTipoPage';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
export const ModalAgregaTipoServicioComponent = () => {
    const {modalAgregaTipoServicio, setModalAgregaTipoServicio, obtenerTipos, tipoServicioSel, setTipoServicioSel} = useContext(TiposServicioContext);
    const [tipoServicio, setTipoServicio] = useState();
    const [errorGuardado, setErrorGuardado] = useState(false);
    const [idTipoServicio, setIdTipoServicio] = useState(0)
    const refForm = useRef();
    console.log('Valor de modal agrega', modalAgregaTipoServicio);

    const handleClose = () => {
        setModalAgregaTipoServicio(false);
    }

    const verificaAccion =()=> {
      console.log('tipo de servicio en modal', tipoServicioSel)
      if(tipoServicioSel?.idTipoServicio) {
        console.log('editar tipo de servicio')
        setTipoServicio(tipoServicioSel?.descripcion);
        setIdTipoServicio(tipoServicioSel?.idTipoServicio);
      } else {
        console.log('agregar tipo de servicio')
        setTipoServicio('');
        setIdTipoServicio(0);
      }
    }

    useEffect(() => {
      verificaAccion()
    }, [tipoServicioSel])
    

    const handleSubmit =  (event) => {
        event.preventDefault();
        //refForm.current.isValidate();
        GuardarNuevoTipoServicio(tipoServicio, idTipoServicio).then(respuesta => {
            console.log('respuesta de guardado en modal', respuesta);
            if(respuesta!=1) {
                setErrorGuardado(true);
            } else{
                setErrorGuardado(false);
                obtenerTipos();
                handleClose();

            }
        })
    }

  return (
      <div
        style={{
            minWidth:600
        }}
    >
     <Dialog open={modalAgregaTipoServicio} onClose={handleClose}>
        <form onSubmit={handleSubmit} ref={refForm}>
        <DialogTitle>Tipo de Servicio</DialogTitle>
        <DialogContent
            style={{minWidth:600}}
        >
          <TextField
            autoFocus
            margin="dense"
            id="name"
            name="txtTipoServicio"
            label="Descricipción del tipo de Servicio"
            type="text"
            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => setTipoServicio(e.target.value)}
            value={tipoServicio}
          />
          {
            errorGuardado && (
              <Typography
                style={{
                    fontSize:12,
                    color:'red'
                }}
              >
                Error al guardar
            </Typography>
            )
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type='submit' >Guardar</Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
